<script>
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Points Balance': 'Meus Pontos › Saldo',
      'Available': 'Disponível',
      'Earned': 'Acumulado',
      'Spent': 'Utilizado',
      'View extract': 'Ver extrato',
      'View experiences': 'Ver experiências',
      'pts': 'pts',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',
    },
    es: {
      'Points Balance': 'Mis Puntos › Saldo',
      'Available': 'Disponible',
      'Earned': 'Acumulado',
      'Spent': 'Utilizado',
      'View extract': 'Ver extracto',
      'View experiences': 'Ver experiencias',
      'pts': 'pts',
      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtelo de nuevo más tarde.',
    }
  },
  components: { Layout, Breadcrumb },
  data() {
    return {
      loading: true,
      errored: false,
      summary: {
        available: 0,
        earned: 0,
        spent: 0,
      },
    };
  },
  methods: {
    getSummary() {
      this.loading = true
      this.errored = false

      api
        .get('points/summary')
        .then(response => {
          if (response.data.status == 'success') {
            this.summary = response.data.summary
          } else {
            this.errored = true
          }
        })
        .catch(error => {
          this.errored = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  mounted() {
    this.getSummary()
  }
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Meus Pontos' }, { text: 'Saldo' }]" />
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-md-flex justify-content-between">
          <h3 class="mb-0">{{ t('Points Balance') }}</h3>
        </div>
      </div>
    </div>

    <div v-if="errored" class="card">
      <div class="card-body">{{ t('We apologize, we are unable to retrieve information at this time. Please try again later.') }}</div>
    </div>

    <div v-else class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
            <p class="text-muted text-uppercase font-size-12 mb-2">{{ t('Available') }}</p>
            <h1 class="mb-4 notranslate">
              <span v-if="loading">-</span>
              <span v-else>{{ summary.available | points }} {{ t('pts') }}</span>
            </h1>
            <router-link to="/points/extract" class="btn btn-default mr-2 mb-2">{{ t('View extract') }}</router-link>
            <router-link to="/experiences" class="btn btn-outline-default mb-2">{{ t('View experiences') }}</router-link>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card">
          <div class="card-body">
            <p class="text-muted text-uppercase font-size-12 mb-2">{{ t('Earned') }}</p>
            <h4 class="mb-0 notranslate text-success">
              <span v-if="loading">-</span>
              <span v-else>{{ summary.earned | points }} {{ t('pts') }}</span>
            </h4>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-lg-3">
        <div class="card">
          <div class="card-body">
            <p class="text-muted text-uppercase font-size-12 mb-2">{{ t('Spent') }}</p>
            <h4 class="mb-0 notranslate text-danger">
              <span v-if="loading">-</span>
              <span v-else>{{ summary.spent | points }} {{ t('pts') }}</span>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
